<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">My Leaves</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]"><i class="ti ti-smart-home"></i></a>
          </li>
          <!-- <li class="breadcrumb-item">
              Employee
            </li> -->
          <li class="breadcrumb-item active" aria-current="page">My Leaves</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="me-2 mb-2 d-none">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-2">
        <a
          href="javascript:void(0);"
          class="btn btn-primary d-flex align-items-center"
          (click)="openBusinessModal(addBusinessModals)"
          ><i class="ti ti-circle-plus me-2"></i>Apply Leave</a
        >
      </div>
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <!-- Leaves Info -->
  <!-- <div class="row">
    <div class="col-xl-3 col-md-6">
      <div class="card bg-black-le">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="text-start">
              <p class="mb-1">Annual Leaves <span class="text-danger">*</span></p>
              <h4>05</h4>
            </div>
            <div class="d-flex">
              <div class="flex-shrink-0 me-2">
                <span class="avatar avatar-md d-flex">
                  <i class="ti ti-calendar-event fs-32"></i>
                </span>
              </div>
            </div>
          </div>
          <span class="badge bg-secondary-transparent"
            >Remaining Leaves : 07 <span class="text-danger">*</span></span
          >
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="card bg-blue-le">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="text-start">
              <p class="mb-1">Medical Leaves <span class="text-danger">*</span></p>
              <h4>11</h4>
            </div>
            <div class="d-flex">
              <div class="flex-shrink-0 me-2">
                <span class="avatar avatar-md d-flex">
                  <i class="ti ti-vaccine fs-32"></i>
                </span>
              </div>
            </div>
          </div>
          <span class="badge bg-info-transparent">Remaining Leaves : 01</span>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="card bg-purple-le">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="text-start">
              <p class="mb-1">Casual Leaves <span class="text-danger">*</span></p>
              <h4>02</h4>
            </div>
            <div class="d-flex">
              <div class="flex-shrink-0 me-2">
                <span class="avatar avatar-md d-flex">
                  <i class="ti ti-hexagon-letter-c fs-32"></i>
                </span>
              </div>
            </div>
          </div>
          <span class="badge bg-transparent-purple">Remaining Leaves : 10</span>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="card bg-pink-le">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="text-start">
              <p class="mb-1">Other Leaves <span class="text-danger">*</span></p>
              <h4>07</h4>
            </div>
            <div class="d-flex">
              <div class="flex-shrink-0 me-2">
                <span class="avatar avatar-md d-flex">
                  <i class="ti ti-hexagonal-prism-plus fs-32"></i>
                </span>
              </div>
            </div>
          </div>
          <span class="badge bg-pink-transparent">Remaining Leaves : 05</span>
        </div>
      </div>
    </div>
  </div> -->

  <!-- <div class="leave-carousel-wrapper" *ngIf="leaveInfo.length > 0"> -->
  <div class="leave-carousel-wrapper" *ngIf="leaveCounts.length > 0">
    <!-- Previous Arrow -->
    <button
      type="button"
      class="leave-carousel-arrow leave-carousel-prev"
      (click)="previousLeave()"
      [disabled]="currentLeaveIndex === 0"
    >
      <i class="ti ti-chevron-left"></i>
    </button>

    <div class="leave-carousel">
      <!-- <div
        class="leave-carousel-track"
        [style.transform]="'translateX(-' + currentLeaveIndex * 25 + '%)'"
      > -->
      <div
        class="leave-carousel-track"
        [style.transform]="'translateX(-' + currentLeaveIndex * slideStep + '%)'"
      >
        <!-- <div class="leave-carousel-slide col-xl-3 col-md-6" *ngFor="let leave of leaveInfo"> -->
        <div
          class="leave-carousel-slide col-xl-3 col-md-6"
          *ngFor="let leave of leaveCounts; let i = index"
        >
          <!-- <div class="card bg-black-le"> -->
          <!-- <div class="card" [ngClass]="getLeaveCardColor(i)"> -->
          <div class="card leave-count-card">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="text-start">
                  <p class="mb-1">
                    {{ leave.leaveType }}
                    <!-- <span class="text-danger">*</span> -->
                  </p>

                  <h4>{{ leave.count }}</h4>
                </div>

                <div class="d-flex">
                  <div class="flex-shrink-0 me-2">
                    <span class="avatar avatar-md d-flex">
                      <!-- <i class="ti ti-calendar-event fs-32"></i> -->
                    </span>
                  </div>
                </div>
              </div>

              <span class="badge bg-secondary-transparent">
                Remaining Leaves : {{ leave.remainingLeaves }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Next Arrow -->
    <!-- <button
      type="button"
      class="leave-carousel-arrow leave-carousel-next"
      (click)="nextLeave()"
      [disabled]="currentLeaveIndex >= leaveInfo.length - 1"
    > -->
    <!-- <button
      type="button"
      class="leave-carousel-arrow leave-carousel-next"
      (click)="nextLeave()"
      [disabled]="leaveCounts.length <= 4 || currentLeaveIndex >= leaveCounts.length - 4"
    > -->
    <button
      type="button"
      class="leave-carousel-arrow leave-carousel-next"
      (click)="nextLeave()"
      [disabled]="leaveCounts.length <= cardsPerView || currentLeaveIndex >= maxLeaveIndex"
    >
      <i class="ti ti-chevron-right"></i>
    </button>
  </div>

  <!-- <div class="row">
    <div class="col-xl-3 col-md-6" *ngFor="let leave of leaveInfo">
      <div class="card bg-black-le">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="text-start">
              <p class="mb-1">
                {{ leave.leaveType }}
                <span class="text-danger">*</span>
              </p>

              <h4>{{ leave.count }}</h4>
            </div>

            <div class="d-flex">
              <div class="flex-shrink-0 me-2">
                <span class="avatar avatar-md d-flex">
                  <i class="ti ti-calendar-event fs-32"></i>
                </span>
              </div>
            </div>
          </div>

          <span class="badge bg-secondary-transparent"> Remaining Leaves : - </span>
        </div>
      </div>
    </div>
  </div> -->
  <!-- /Leaves Info -->

  <!-- Leaves list -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <div class="d-flex">
        <h5 class="me-2">Leave List</h5>
        <!-- <span class="badge bg-primary-transparent me-2">
          Total Leaves : 48 
          <span class="text-danger">*</span></span
        >
        <span class="badge bg-secondary-transparent"
          >Total Remaining Leaves : 23 <span class="text-danger">*</span></span
        > -->
      </div>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>

        <ng-container *ngIf="dateRange">
          <div class="me-3">
            <div class="input-icon position-relative">
              <span class="input-icon-addon">
                <i class="ti ti-calendar text-gray-9"></i>
              </span>
              <input
                type="text"
                id="dateRangeInput"
                class="form-control date-range bookingrange"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"
                [(ngModel)]="dateRange"
                (ngModelChange)="loadAppliedLeaves()"
                ngxDaterangepickerBootstrap
                [locale]="{ applyLabel: 'ok', format: 'DD-MM-YYYY' }"
                startKey="startDate"
                endKey="endDate"
                style="width: 205px"
              />
            </div>
          </div>
        </ng-container>
        <div class="me-3">
          <!-- <select class="form-select" [(ngModel)]="leaveType" (change)="loadAppliedLeaves()">
            <option value="" selected>Select Type</option>
            <option [value]="leaveTypeEnum.LEAVEWITHOUTPAY">
              {{ leaveTypeEnum.LEAVEWITHOUTPAY }}
            </option>
            <option [value]="leaveTypeEnum.CASUAL">{{ leaveTypeEnum.CASUAL }}</option>
            <option [value]="leaveTypeEnum.SICK">{{ leaveTypeEnum.SICK }}</option>
          </select> -->
          <select class="form-select" [(ngModel)]="leaveType" (change)="loadAppliedLeaves()">
            <option value="" selected>Select Leave Type</option>
            <option *ngFor="let leave of leaveTypes" [value]="leave">
              {{ leave }}
            </option>
          </select>
        </div>
        <div class="me-3">
          <select class="form-select" [(ngModel)]="status" (change)="loadAppliedLeaves()">
            <option value="" selected>Select Status</option>
            <option [value]="statusEnum.APPROVED">{{ statusEnum.APPROVED }}</option>
            <!-- <option [value]="statusEnum.PENDING">{{ statusEnum.PENDING }}</option> -->
            <option [value]="statusEnum.REJECTED">{{ statusEnum.REJECTED }}</option>
            <option [value]="statusEnum.CANCELLED">{{ statusEnum.CANCELLED }}</option>
            <!-- <option [value]="statusEnum.CANCELREQUESTED">{{ statusEnum.CANCELREQUESTED }}</option> -->
            <option [value]="statusEnum.PENDING">
              {{ statusEnum.PENDING }} / {{ statusEnum.CANCELREQUESTED }}
            </option>
          </select>
        </div>
        <div class="me-3 d-none">
          <div class="input-icon position-relative">
            <input
              type="text"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
            />
            <span class="input-icon-addon">
              <i class="ti ti-chevron-down"></i>
            </span>
          </div>
        </div>
        <div class="dropdown me-3 d-none">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            Leave Type
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Medical Leave</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Casual Leave</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Annual Leave</a>
            </li>
          </ul>
        </div>
        <div class="dropdown me-3 d-none">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            Approved By
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Doglas Martini</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Warren Morales</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Doglas Martini</a>
            </li>
          </ul>
        </div>
        <div class="dropdown me-3 d-none">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            Select Status
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a
                href="javascript:void(0);"
                class="dropdown-item rounded-1 d-flex justify-content-start align-items-center"
                ><span
                  class="rounded-circle bg-transparent-success d-flex justify-content-center align-items-center me-2"
                  ><i class="ti ti-point-filled text-success"></i></span
                >Approved</a
              >
            </li>
            <li>
              <a
                href="javascript:void(0);"
                class="dropdown-item rounded-1 d-flex justify-content-start align-items-center"
                ><span
                  class="rounded-circle bg-transparent-danger d-flex justify-content-center align-items-center me-2"
                  ><i class="ti ti-point-filled text-danger"></i></span
                >Declined</a
              >
            </li>
            <li>
              <a
                href="javascript:void(0);"
                class="dropdown-item rounded-1 d-flex justify-content-start align-items-center"
                ><span
                  class="rounded-circle bg-transparent-purple d-flex justify-content-center align-items-center me-2"
                  ><i class="ti ti-point-filled text-purple"></i></span
                >New</a
              >
            </li>
          </ul>
        </div>
        <div class="dropdown d-none">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            Sort By : Last 7 Days
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Recently Added</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Ascending</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Desending</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Last Month</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Last 7 Days</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <ng-container *ngIf="appliedLeaves$ | async as leaves">
          <table class="table datatable" *ngIf="leaves.length > 0; else noRecords">
            <thead class="thead-light">
              <tr>
                <!-- <th class="no-sort">
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox" id="select-all">
                  </div>
                </th> -->
                <th>Leave Type</th>
                <th>From</th>
                <th>To</th>
                <th>Approvers</th>
                <th>Approved By</th>
                <th>Submitted On</th>
                <th>No. of Days</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let leave of appliedLeaves$ | async">
                <td>
                  <div class="d-flex align-items-center">
                    <p class="fs-14 fw-medium d-flex align-items-center mb-0">
                      {{ leave.leaveType }}
                    </p>
                    <a
                      href="javascript:void(0)"
                      class="ms-2"
                      [attr.aria-label]="leave.reason"
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      [attr.data-bs-title]="leave.reason"
                      ngbTooltip="{{ leave.reason }}"
                      placement="right"
                    >
                      <i class="ti ti-info-circle text-info"></i>
                    </a>
                  </div>
                </td>
                <td>
                  {{ leave.fromDate | date }}
                </td>
                <td>
                  {{ leave.toDate | date }}
                </td>
                <td>
                  <div class="d-flex align-items-center file-name-icon">
                    <div class="ms-2">
                      <h6 class="fw-medium" *ngIf="leave.leavemanager?.firstName">
                        <a href="javascript:void(0);"
                          >{{ leave.leavemanager?.firstName }} {{ leave.leavemanager?.lastName }}</a
                        >
                      </h6>

                      <hr
                        *ngIf="
                          leave.managerId !== leave.requestManagerId &&
                          leave.leaverequestManager?.firstName
                        "
                      />

                      <h6
                        class="fw-medium"
                        *ngIf="
                          leave.managerId !== leave.requestManagerId &&
                          leave.leaverequestManager?.firstName
                        "
                      >
                        <a href="javascript:void(0);"
                          >{{ leave.leaverequestManager?.firstName }}
                          {{ leave.leaverequestManager?.lastName }}</a
                        >
                      </h6>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    class="d-flex align-items-center file-name-icon"
                    *ngIf="leave.status !== 'Pending' && leave.approver"
                  >
                    <!-- <a href="javascript:void(0);" class="avatar avatar-md border avatar-rounded">
                    <img
                      [src]="
                        leave.approver.picture ? apiEndpoint + leave.approver.picture : defaultImg
                      "
                      class="img-fluid rounded-circle"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2">
                    <h6 class="fw-medium">
                      <a href="javascript:void(0);">{{ leave.approver.firstName }}</a>
                    </h6>
                  </div> -->
                    <ng-container *ngIf="leave.approver.picture; else initials">
                      <img
                        [src]="apiEndpoint + '/uploads/' + leave.approver.picture"
                        class="img-fluid rounded-circle"
                        alt="img"
                        style="width: 40px; height: 40px; object-fit: cover"
                      />
                    </ng-container>

                    <ng-template #initials>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                        style="width: 30px; height: 30px"
                        >{{ getInitials(leave.approver.firstName, leave.approver.lastName) }}</span
                      >
                    </ng-template>
                    <div class="ms-2">
                      <h6 class="fw-medium">
                        <a href="javascript:void(0);"
                          >{{ leave.approver.firstName }} {{ leave.approver.lastName }}</a
                        >
                      </h6>
                    </div>
                  </div>
                </td>
                <td>{{ leave.createdAt | date: 'medium' }}</td>
                <td>{{ leave.leaveDays }}</td>
                <td>
                  <span
                    *ngIf="leave.status === 'Approved'"
                    class="badge badge-success d-inline-flex align-items-center badge-xs"
                  >
                    {{ leave.status }}</span
                  >
                  <span
                    *ngIf="leave.status === 'Cancelled' || leave.status === 'Rejected'"
                    class="badge badge-danger d-inline-flex align-items-center badge-xs"
                  >
                    {{ leave.status }}</span
                  >
                  <span
                    *ngIf="leave.status === 'Pending'"
                    class="badge badge-warning d-inline-flex align-items-center badge-xs"
                  >
                    {{ leave.status }}</span
                  >
                  <span
                    *ngIf="leave.status === 'Cancel Requested'"
                    class="badge badge-info d-inline-flex align-items-center badge-xs"
                  >
                    {{ leave.status }}
                  </span>

                  <!-- <div class="dropdown">
                    <a href="javascript:void(0);"
                      class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown">
                      <span
                        class="rounded-circle bg-transparent-success d-flex justify-content-center align-items-center me-2"><i
                          class="ti ti-point-filled text-success"></i></span> Approved
                    </a>
                    <ul class="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <a href="javascript:void(0);"
                          class="dropdown-item rounded-1 d-flex justify-content-start align-items-center"><span
                            class="rounded-circle bg-transparent-success d-flex justify-content-center align-items-center me-2"><i
                              class="ti ti-point-filled text-success"></i></span>Approved</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);"
                          class="dropdown-item rounded-1 d-flex justify-content-start align-items-center"><span
                            class="rounded-circle bg-transparent-danger d-flex justify-content-center align-items-center me-2"><i
                              class="ti ti-point-filled text-danger"></i></span>Declined</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);"
                          class="dropdown-item rounded-1 d-flex justify-content-start align-items-center"><span
                            class="rounded-circle bg-transparent-purple d-flex justify-content-center align-items-center me-2"><i
                              class="ti ti-point-filled text-purple"></i></span>New</a>
                      </li>
                    </ul>
                  </div> -->
                </td>
                <td>
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0)"
                      data-bs-toggle="modal"
                      data-bs-target="#view_details"
                      (click)="openOffcanvasLeave(leave)"
                      title="View Leave Detail"
                    >
                      <i class="ti ti-eye"></i>
                    </a>
                    <!-- <a href="#" class="me-2" data-bs-toggle="modal" data-bs-target="#edit_leaves"><i
                        class="ti ti-edit"></i></a>
                    <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#delete_modal"><i
                        class="ti ti-trash"></i></a> -->
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Approve')"
                      title="Approve"
                      *ngIf="leave.status === 'Cancel Requested' && isBusinessOwner()"
                    >
                      <i class="ti ti-check text-success"></i>
                    </a>

                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Reject')"
                      title="Reject"
                      *ngIf="leave.status === 'Cancel Requested' && isBusinessOwner()"
                    >
                      <i class="ti ti-ban text-danger"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Cancel')"
                      title="Cancel"
                      *ngIf="leave.status !== 'Cancelled' && leave.status !== 'Rejected'"
                      ><i class="ti ti-x text-warning"></i
                    ></a>
                    <!-- <button
                    type="button"
                    *ngIf="leave.status === 'Pending'"
                    class="btn btn-danger"
                    (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Cancel')"
                  >
                    Cancel
                  </button> -->
                  </div>
                </td>
              </tr>
            </tbody>
            <ng-template #noRecords>
              <tr>
                <td colspan="6" class="text-center">Record not available</td>
              </tr>
            </ng-template>
          </table>
        </ng-container>
        <ng-template #noRecords>
          <!-- <div class="d-flex align-items-center justify-content-between ms-2 text-center"> -->
          <div class="text-center">Record not available</div>
          <!-- </div> -->
        </ng-template>
      </div>
    </div>
    <!-- <div class="has-text-centered mt-3" *ngIf="appliedLeaveList.length > 0">
        <app-pagination [currentPage]="currentPage" [pageSize]="pageLimit" [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"></app-pagination>
      </div> -->

    <ng-container *ngIf="appliedLeaves$ | async as leaves">
      <div class="d-flex align-items-center justify-content-between ms-2" *ngIf="leaves.length > 0">
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalCount }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </ng-container>
    <!-- /Leaves list -->
  </div>
</div>

<!-- Add Leaves -->
<ng-template #addBusinessModals let-modal class="custom-modal-width">
  <!-- <div class="modal fade" id="add_leaves">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Apply Leave</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label">Leave Policy <span class="text-danger">*</span></label>
            <!-- <select class="form-select" formControlName="leaveType">
              <option value="" selected>Select Type</option>
              <option [value]="leaveTypeEnum.LEAVEWITHOUTPAY">
                {{ leaveTypeEnum.LEAVEWITHOUTPAY }}
              </option>
              <option [value]="leaveTypeEnum.CASUAL">{{ leaveTypeEnum.CASUAL }}</option>
              <option [value]="leaveTypeEnum.SICK">{{ leaveTypeEnum.SICK }}</option>
            </select> -->
            <!-- <select class="form-select" formControlName="leaveType">
              <option value="" selected>Select Type</option>
              <option *ngFor="let leave of leaveTypes" [value]="leave">
                {{ leave }}
              </option>
            </select> -->
            <ng-select
              class="me-3 w-100"
              [items]="leavePolicies$ | async"
              bindValue="leavePolicy"
              placeholder="Select Leave Policy"
              [searchable]="true"
              [clearable]="true"
              style="width: 200px"
              formControlName="leavePolicy"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.leavePolicy?.title | capitalize }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div class="d-flex justify-content-between w-100">
                  <span>{{ item.leavePolicy?.title | capitalize }}</span>
                  <span>{{ item.currentBalance }} Days</span>
                </div>
              </ng-template>
            </ng-select>

            <div *ngIf="form.get('leaveType')?.invalid && form.get('leaveType')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('leaveType') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label">From - To <span class="text-danger">*</span></label>
            <input
              type="text"
              id="dateRangeInputModal"
              class="form-control date-range bookingrange"
              formControlName="daterange"
              appTrimInput
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
              bsdaterangepicker
              style="width: 100%"
            />
            <!-- <input type="date" class="form-control datetimepicker" placeholder="dd/mm/yyyy" formControlName="fromDate"
              (change)="onFromDateChange(); generateDateRange();"  > -->
            <!-- <div class="input-icon position-relative">
              <input type="date" class="form-control datetimepicker" placeholder="dd/mm/yyyy"
                formControlName="fromDate" (change)="onFromDateChange()" [Disabled]="disabledDates"> -->
            <!-- <ngb-datepicker  formControlName="fromDate"  [markDisabled]="isDisabled"> </ngb-datepicker> -->

            <!-- <span class="input-icon-addon">
                                            <i class="ti ti-calendar text-gray-7"></i>
                                        </span> -->
            <div *ngIf="form.get('fromDate')?.invalid && form.get('fromDate')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('fromDate') }}
              </span>
            </div>

            <!-- </div> -->
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <!-- Show Half Day Selection for Each Date -->

            <div *ngFor="let day of dateRangeforHalfDay; let i = index">
              <div class="ms-3">
                <label class="form-label fw-bold me-2">{{ day.date | date: 'dd MMMM yyyy' }}</label>

                <!-- Full Day / Half Day Selection -->
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    [name]="'dayOption' + i"
                    (change)="setDayType(i, 'FullDay')"
                    [checked]="day.selectionType === 'FullDay'"
                  />
                  <label class="form-check-label">Full Day</label>
                </div>

                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    [name]="'dayOption' + i"
                    (change)="setDayType(i, 'HalfDay')"
                    [checked]="day.selectionType === 'HalfDay'"
                  />
                  <label class="form-check-label">Half Day</label>
                </div>

                <!-- Show Half Day Options Only if Half Day is Selected -->
                <div class="ms-5 mb-2" *ngIf="day.selectionType === 'HalfDay'">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [name]="'halfDayOption' + i"
                      (change)="onHalfDayChange(i, 'FirstHalf')"
                      [checked]="day.halfDayOption === 'FirstHalf'"
                    />
                    <label class="form-check-label">First Half</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [name]="'halfDayOption' + i"
                      (change)="onHalfDayChange(i, 'SecondHalf')"
                      [checked]="day.halfDayOption === 'SecondHalf'"
                    />
                    <label class="form-check-label">Second Half</label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ensure that First Half and Second Half are not shown when Full Day is selected -->
            <div *ngIf="form.get('offType')?.value === offTypeEnum.FULLDAY">
              <!-- Logic for full day selection, if needed -->
            </div>

            <div *ngIf="form.get('offType')?.invalid && form.get('offType')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('offType') }}
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6">
          <div class="mb-3">
            <select class="form-select" formControlName="offType">
              <option value="" selected>Select Type</option>
              <option [value]="offTypeEnum.FullDay">{{ offTypeEnum.FullDay }}</option>
              <option [value]="offTypeEnum.FirstHalf">{{ offTypeEnum.FirstHalf }}</option>
              <option [value]="offTypeEnum.SecondHalf">{{ offTypeEnum.SecondHalf }}</option>
            </select>
            <div *ngIf="form.get('offType')?.invalid && form.get('offType')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('offType') }}
              </span>
            </div>
          </div>
        </div> -->
        <div class="col-md-6 d-none">
          <div class="mb-3">
            <label class="form-label">No. of Days</label>
            <input type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="col-md-6 d-none">
          <div class="mb-3">
            <label class="form-label">Remaining Days</label>
            <input type="text" class="form-control" value="8" disabled />
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label">Reason</label>
            <textarea
              class="form-control"
              rows="3"
              formControlName="reason"
              appTrimInput
            ></textarea>
            <div *ngIf="form.get('reason')?.invalid && form.get('reason')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('reason') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="!form.valid">
        Apply Leave
      </button>
    </div>
  </form>
  <!-- </div>
  </div>
</div> -->
</ng-template>
<!-- /Add Leaves -->

<ng-template #cancelAppliedLeaveModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span class="avatar avatar-xl mb-3" class="bg-transparent-danger text-danger">
      <i class="ti ti-lock fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Cancellation</h4>
    <p class="mb-3">Do you want to cancel the leave?</p>
    <form [formGroup]="form">
      <div class="col-md-12">
        <div class="mb-3">
          <label class="form-label">Reason</label>
          <textarea
            class="form-control"
            rows="3"
            formControlName="statusReason"
            appTrimInput
          ></textarea>
          <div *ngIf="form.get('statusReason')?.invalid && form.get('statusReason')?.touched">
            <span class="text-danger">
              {{ getErrorMessage('statusReason') }}
            </span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <a
          href="javascript:void(0);"
          class="btn btn-light me-3"
          data-bs-dismiss="modal"
          (click)="onClose()"
          >Cancel</a
        >
        <a href="javascript:void(0);" class="btn btn-danger" (click)="onSubmit()">Yes, Cancel</a>
      </div>
    </form>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>

<!-- leave details -->
<div
  class="modal fade"
  id="view_details"
  tabindex="-1"
  aria-labelledby="viewDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewDetailsLabel">Request Details</h5>
        <button
          type="button"
          class="btn-close custom-btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedLeave">
        <p>
          <strong>Employee:</strong> {{ selectedLeave.user?.firstName }}
          {{ selectedLeave.user?.lastName }}
        </p>
        <p>
          <strong>Applied By:</strong> {{ selectedLeave.appliedByUser?.firstName }}
          {{ selectedLeave.appliedByUser?.lastName }}
        </p>
        <p><strong>Leave Type:</strong> {{ selectedLeave.leaveType }}</p>
        <p>
          <strong>Date Range:</strong> {{ selectedLeave.fromDate | date: 'mediumDate' }} -
          {{ selectedLeave.toDate | date: 'mediumDate' }}
        </p>
        <p><strong>No. of Days:</strong> {{ selectedLeave.leaveDays }}</p>
        <p><strong>Status:</strong> {{ selectedLeave.status }}</p>
        <p>
          <strong>Approved By:</strong> {{ selectedLeave.approver?.firstName }}
          {{ selectedLeave.approver?.lastName }}
        </p>
        <p><strong>Reason:</strong> {{ selectedLeave.reason }}</p>

        <div *ngIf="selectedLeave.dateRangeforHalfDay">
          <hr />
          <h6 class="mt-2">Requested Dates:</h6>
          <ul class="list-group">
            <li
              *ngFor="let day of parsedDateRange; let i = index"
              class="list-group-item d-flex justify-content-between"
            >
              <span>
                <strong>Date:</strong> {{ day.date | date: 'dd MMMM yyyy' }}<br />
                <strong>For:</strong> {{ day.selectionType }}
                {{ day.halfDayOption ? ' - ' + day.halfDayOption : '' }}
              </span>
            </li>
          </ul>
        </div>
        <!-- Add more fields as needed -->
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div> -->
    </div>
  </div>
</div>

<!-- end leave details -->
